import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import fetchData from '../libs/api';
import { createLogin, isLoggedIn } from '../libs/auth';
import { isValidEmail } from '../utils/isValidEmail';
import { showErrorToast, showSuccessToast } from '../utils/toast';
import './css/login.css';
import Loader from './global/Loader';

const login = async (email, password) => {
    const jsonData = await fetchData('/inspection/api/v1/auth/login', 'POST', {
        email,
        password,
    });

    const message = jsonData.message;
    if (!jsonData.success)
        // eslint-disable-next-line no-throw-literal
        throw {
            message,
        };
    createLogin(jsonData.data.id, jsonData.data.email, jsonData.data.accessToken);

    return { success: true, message: message };
};

const Login = () => {
    const router = useHistory();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [loader, setLoader] = useState(false);

    const handleLogin = useCallback(() => {
        setLoader(true);
        if (!isValidEmail(email)) {
            setEmailError('Email is invalid!');
        } else if (password.trim() === '') {
            setPasswordError('Password cannot be empty!');
        } else {
            setEmailError('');
            setPasswordError('');
            login(email, password)
                .then((result) => {
                    console.log(result);
                    if (result.success) {
                        showSuccessToast(result.message);
                        window.location.href = '/home';
                        // router.push('/home');
                    }
                })
                .catch((error) => {
                    console.log(error);
                    showErrorToast(error.message ?? 'Something went wrong!');
                })
                .finally(() => setLoader(false));
        }
    }, [email, password, router]);

    const Error = (text) =>
        !text ? null : (
            <p
                style={{
                    color: 'red',
                    fontSize: '14px',
                }}
            >
                {text}
            </p>
        );

    useEffect(() => {
        if (isLoggedIn()) {
            router.push('/home');
        }
    }, [router]);

    return (
        <>
            <div
                className="authincation h-100"
                style={{
                    backgroundImage: `url(
            "/images/blackcar.png"
          )`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                }}
            >
                <div className="container h-100">
                    <div className="row justify-content-center h-100 align-items-center">
                        <div className="col-md-6">
                            <div className="authincation-content">
                                <div className="row no-gutters">
                                    <div className="col-xl-12">
                                        <div className="auth-form">
                                            <div className="text-center mb-3">
                                                <a href="index.html">
                                                    <img
                                                        src="/images/carniba_logo.png"
                                                        alt="carniba"
                                                        style={{ width: '60px' }}
                                                    />
                                                </a>
                                            </div>
                                            {/* <h3 className="text-center mb-4 text-white">
                        Carniba Inspection
                      </h3> */}
                                            <form className="mt-4">
                                                <div className="form-group">
                                                    <label htmlFor="email" className="mb-1 text-white">
                                                        <strong>Email</strong>
                                                    </label>
                                                    <input
                                                        type="email"
                                                        id="email"
                                                        name="email"
                                                        className="form-control login_input"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                        autoComplete="false"
                                                    />
                                                    {Error(emailError)}
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="email" className="mb-1 text-white">
                                                        <strong>Password</strong>
                                                    </label>
                                                    <input
                                                        type="password"
                                                        id="password"
                                                        name="password"
                                                        className="form-control login_input"
                                                        value={password}
                                                        onChange={(e) => setPassword(e.target.value)}
                                                    />
                                                    {Error(passwordError)}
                                                </div>
                                                <div className="text-center login_btn_div">
                                                    {loader ? (
                                                        <>
                                                            <Loader />
                                                        </>
                                                    ) : (
                                                        <>
                                                            <button
                                                                type="button"
                                                                className="btn bg-white text-primary btn-block login_btn"
                                                                onClick={() => handleLogin()}
                                                            >
                                                                Login
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Login;
